import CertificateExpired from "../images/certificate_expired.svg";
import CertificateAdded from "../images/certificate_added.svg";
import { NotificationInterface } from "../interfaces/NotificationInterface";

type NotificationItem = {
    icon?: {
        url?: string;
        backgroundColor?: string;
    };
    showButtons?: boolean;
    type?: NotificationType;
    title: string;
    date: string;
    onClick?: () => void;
};

export enum NotificationType {
    CERTIFICATE_EXPIRED = "certificate_expired",
    CERTIFICATE_ADDED = "certificate_added",
}

export const formatNotificationDate = (date: string): string => {
    const dateArray: string[] = date.split("-");
    const dateYear: string[] = dateArray[2].split(" ");
    const formattedDate: Date = new Date(
        Number(dateYear[0]),
        Number(dateArray[1]) - 1,
        Number(dateArray[0]),
    );

    const options: Intl.DateTimeFormatOptions = {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
    };

    return new Intl.DateTimeFormat("nl-NL", options).format(formattedDate);
};

export const mapNotificationToItem = (
    notifications: NotificationInterface[],
    count: number,
    showButtons?: boolean,
    handleButtonClick?: (notification: NotificationInterface) => void,
): NotificationItem[] => {
    return notifications
        ?.map((notification) => {
            const icon = {
                url:
                    notification.badge.icon ===
                    NotificationType.CERTIFICATE_ADDED
                        ? CertificateAdded
                        : CertificateExpired,
                backgroundColor:
                    notification.badge.icon ===
                    NotificationType.CERTIFICATE_ADDED
                        ? "#7CBF3F1A"
                        : "#E33F3F1A",
            };

            return {
                icon: icon,
                showButtons: !!(
                    showButtons &&
                    notification.badge.icon ===
                        NotificationType.CERTIFICATE_EXPIRED
                ),
                type: notification.badge.icon as NotificationType,
                onClick: () =>
                    handleButtonClick ? handleButtonClick(notification) : null,
                title: notification.title,
                date: formatNotificationDate(notification.description),
            };
        })
        .slice(0, count);
};
